<template>
  <div class="header">
    <b-navbar v-bind:class="{ 'menu-bg' : isAppear }" toggleable="lg" type="dark">
      <router-link class="logo" to="/">
        <img alt="東栄運輸株式会社" src="../assets/logo.png">
      </router-link>
      <b-navbar-toggle class="humberger" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <li class="nav-item" v-for="(item, index) in items" :key=index>
            <router-link class="nav-link" v-bind:to=item.path>
                {{ item.title }}
            </router-link>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      items: [
        { title: 'TOP', path: '/' },
        { title: 'BUS', path: '/bus' },
        { title: 'CARGO', path: '/cargo' },
        { title: 'CONSTRUCTION', path: '/construction' },
        { title: 'SAFETY', path: '/safety' },
        { title: 'CORPORATION', path: '/corporation' },
        { title: 'RECRUIT', path: '/recruit' }
      ],
      isAppear: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isAppear = window.pageYOffset > 50
    }
  }
}
</script>

<style scoped>
.navbar-collapse.collapse {
  justify-content: flex-end;
}
.menu-bg {
  background: black;
  transition: all 0.5s ease;
}
.menu-list {
  margin-top: 20.97px;
}
.humberger {
  border-color: rgba(255, 255, 255, 0.0)!important;
}

.nav-item a {
  color: #FFFFFF;
}
.nav-item {
  padding-left: 47px;
}
.nav-link {
  color: #FFFFFF!important;
  font-size: 18px!important;
}
.header {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  color: #fff;
}
.logo {
  display: block;
  height: 100%;
  width: 100%;
  max-width: 120px;
}

.logo img {
  height: 45px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue